<template>
  <div >
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title class = "heading" v-if="mode==='createItem'">Create DO Item</md-dialog-title>
      <md-dialog-title class = "heading" v-if="mode==='updateItem'">Update DO Item</md-dialog-title>
      
      <md-dialog-content >
        <form id = "top" novalidate @submit.prevent="doSaveUser">
          <div class = "down">

            <div class = "inputBoxDoubleDoitem">
              <div class = "inputSpaceDisable">
                <md-field>
                    <label>Sales Office</label>
                    <md-input v-model="dataForm.salesOffice" disabled/>
                </md-field>
              </div>

              <div class = "inputSpaceDisable">
                <md-field>
                    <label>Order Type</label>
                    <md-input v-model="dataForm.deliveryType" disabled/>
                </md-field>
              </div>

              <div class = "inputSpaceDisable">
                <md-field>
                    <label>Delivery Order</label>
                    <md-input v-model="dataForm.deliveryOrder" disabled/>
                </md-field>
              </div>

              <div class = "inputSpaceDisable">
                <md-field>
                    <label>Load ID</label>
                    <md-input v-model="dataForm.seqNo" disabled/>
                </md-field>
              </div>


            </div>



            <div class = "inputBoxDoubleDoitem">
              <!-- <div class = "inputSpace">
                <md-field :class="getValidationClass('dataForm.yard')">
                  <label for="yard">Yard</label>
                  <md-input name="yard"
                            id="yard"
                            autocomplete="new-password"
                            v-model="dataForm.yard"
                  />
                </md-field>
              </div> -->



              <!-- <div class = "inputSpace">
                <md-field :class="getValidationClass('dataForm.locationNumber')">
                  <label for="locationNumber">Location</label>
                    <md-input name="locationNumber"
                              id="locationNumber"
                              autocomplete="new-password"
                              v-model="dataForm.locationNumber"
                    />
                </md-field>
              </div> -->

              <div class = "inputSpace">
                <auto-complete-master-data-select v-if="mode != 'status'" :class="getValidationClass('dataForm.source')"
                                                    group="GST_SOURCE"
                                                    label="Source"
                                                    :init-value="dataForm.source"
                                                    :on-item-changed="handleSourceChanged"
                                                    >
                </auto-complete-master-data-select>
              </div>

              <div class = "inputSpace">
                <auto-complete-master-data-select :class="getValidationClass('dataForm.receivingWindows')"
                                                    group="REC_WINDOW"
                                                    label="Rec. Window"
                                                    :init-value="dataForm.receivingWindows"
                                                    :on-item-changed="handleWindowsChanged"
                                                    >
                </auto-complete-master-data-select>
              </div>

              <div class = "inputSpace">
                <AutocompleteSelect
                      label="Ocean Carrier"
                      group="STC_CARRIER"
                      v-model="dataForm.carrier"
                      :on-item-selected="handleCarrierChanged"
                  />
              </div>

              <div class = "inputSpace">
                <auto-complete-master-data-select
                  v-if="dataForm.deliveryType != 'YY'"
                  group="GST_LOAD_STATUS"
                  label="Load Status"
                  :init-value="dataForm.loadStatus"
                  :on-item-changed="handleStatusChanged"
                  :class="getValidationClass('dataForm.loadStatus')">
                </auto-complete-master-data-select>

                <div class = "inputSpace">
                  <md-field v-if="dataForm.deliveryType == 'YY'">
                      <label>Load Status</label>
                      <md-input v-model="dataForm.loadStatus" disabled/>
                  </md-field>
                </div>

              </div>

              <!-- <div class = "inputSpace">
                <md-field :class="getValidationClass('dataForm.customerRef')">
                  <label for="customerRef">CustomerRef</label>
                    <md-input name="customerRef"
                              id="customerRef"
                              autocomplete="new-password"
                              v-model="dataForm.customerRef"
                    />
                </md-field>
              </div>

              <div class = "inputSpace">
                <md-field :class="getValidationClass('dataForm.exti2')">
                  <label for="exti2">External#</label>
                    <md-input name="exti2"
                              id="exti2"
                              autocomplete="new-password"
                              v-model="dataForm.exti2"
                    />
                </md-field>
              </div> -->


            </div>

            <div class = "inputBoxDoubleDoitem">

              <div class = "inputSpace">
                <md-field :class="getValidationClass('dataForm.containerNo')">
                  <label for="containerNo">Container #</label>
                  <md-input name="containerNo"
                            id="containerNo"
                            autocomplete="new-password"
                            v-model="dataForm.containerNo"
                            />
                    <div>
                    <div class="md-error" v-if="!$v.dataForm.containerNo.maxLength">Container length is 11!<br/></div>
                    <div class="md-error" v-else-if="!$v.dataForm.containerNo.minLength">Container min length is 10!<br/></div>
                    </div>
                </md-field>
              </div>

              
              <div  class = "inputSpace" :class="getValidationClass('dataForm.moveInDate')">
                <datepicker v-model="dataForm.moveInDate">
                  <label>Move In Date</label>
                </datepicker>
              </div>


              <!-- <div class = "inputSpace">
                <div :class="getValidationClass('dataForm.moveInTime')" >
                  <md-field>
                    <label>Move In Time</label>
                    <md-input v-model="dataForm.moveInTime" placeholder="Format: HH:MM:SS"></md-input>
                    <span class="md-error" v-if="!$v.dataForm.moveInTime.required">Move in time is required<br/></span>
                    <span class="md-error" v-else-if="!$v.dataForm.moveInTime.add">Move in time format is invalid!<br/></span>
                  </md-field>
                </div>
              </div> -->

              <div class = "inputSpace">
                <md-field :class="getValidationClass('dataForm.moveInBy')">
                  <label for="moveInBy">Move In By</label>
                  <md-input name="moveInBy"
                            id="moveInBy"
                            autocomplete="new-password"
                            v-model="dataForm.moveInBy"
                  />
                </md-field>
              </div>

              <div class = "inputSpace">
                  <auto-complete-master-data-select :class="getValidationClass('dataForm.ctnrType')"
                                                    group="CCR_CNTRTYPE"
                                                    label="Ctnr Type"
                                                    :init-value="dataForm.ctnrType"
                                                    :on-item-changed="handleCtnrTypeChanged"
                                                    >
                </auto-complete-master-data-select>
              </div>

            </div>


            <div class = "inputBoxDoubleDoitem">

              <div class = "inputSpace">
                <md-field :class="getValidationClass('dataForm.chassisNo')">
                <label for="chassisNo">Chassis #</label>
                <md-input name="chassisNo"
                          id="chassisNo"
                          autocomplete="new-password"
                          v-model="dataForm.chassisNo"
                          />
                    <div>
                    <div class="md-error" v-if="!$v.dataForm.chassisNo.maxLength">Container length is between 9 and 15!<br/></div>
                    <div class="md-error" v-else-if="!$v.dataForm.chassisNo.minLength">Container length is between 9 and 15!<br/></div>
                  </div>
                </md-field>
              </div>


              <div class = "inputSpace">
                <div :class="getValidationClass('dataForm.chzStartDate')">
                  <datepicker v-model="dataForm.chzStartDate">
                    <label>Chassis Start Date</label>
                  </datepicker>
                </div>

                <!-- <md-field>
                  <label for="moveInDate">Chassis Start Date</label>
                  <md-input name="chzStartDate"
                            id="chzStartDate"
                            autocomplete="new-password"
                            v-model="dataForm.chzStartDateLocal"
                            />
                </md-field> -->
              </div>

              <!-- <div class = "inputSpace">
                <div :class="getValidationClass('dataForm.chzStartTime')" >
                  <md-field>
                    <label>Chassis Start Time</label>
                    <md-input v-model="dataForm.chzStartTime" placeholder="Format: HH:MM:SS"></md-input>
                    <span class="md-error" v-if="!$v.dataForm.chzStartTime.add">Chassis Start time format is invalid!<br/></span>
                  </md-field>
                </div>
              </div> -->


              <div class = "inputSpace">
                <md-field :class="getValidationClass('dataForm.chassisVendor')">
                  <label for="chassisVendor">Chassis Vendor</label>
                    <md-input name="chassisVendor"
                              id="chassisVendor"
                              autocomplete="new-password"
                              v-model="dataForm.chassisVendor"
                    />
                </md-field>
              </div>

              <div class = "inputSpace">
                <md-field :class="getValidationClass('dataForm.ownChassis')">
                  <label for="ownChassis"> {{dataForm.ownChassis == "YES" ? "Company Own(YES)" : "Not Own(NO)"}}</label>
                  <md-input name="ownChassis"
                            id="ownChassis"
                            autocomplete="new-password"
                            :disabled="true"
                  />
                  <md-checkbox v-model="dataForm.ownChassis" value="YES">
                    <span></span>
                  </md-checkbox>
                </md-field>
              </div>

            </div>



            <div class = "inputBoxDoubleDoitem">
              <!-- <div class = "inputSpace">
                <AutocompleteSelect
                      label="Ocean Carrier"
                      group="GST_CARRIER"
                      v-model="dataForm.carrier"
                      :on-item-selected="handleCarrierChanged"
                  />
              </div> -->
                <!-- <md-field :class="getValidationClass('dataForm.carrier')">
                  <label for="carrier">Ocean Carrier</label>
                  <md-input name="carrier"
                            id="carrier"
                            autocomplete="new-password"
                            v-model="dataForm.carrier"
                  />
                </md-field> -->

              

              <!-- <div class = "inputSpace">
                <div>
                  <autocomplete-ccic-location-select
                      label="Pickup Loc"
                      group="GST_LOCATION"
                      v-model="dataForm.pickupLocation"
                      :on-item-selected="handlePickLocationChanged"
                  />
                </div>
                <master-data-display v-if="dataForm.pickupLocation != null" group="GST_LOCATION" :tag-id="dataForm.pickupLocation"/>
              </div> -->

              <!-- <div class = "inputSpace">
                <md-field :class="getValidationClass('dataForm.scac')">
                      <label for="scac">Truck SCAC</label>
                      <md-input name="scac"
                              id="scac"
                              autocomplete="new-password"
                              v-model="dataForm.scac"
                      />
                </md-field>
              </div> -->

                <!-- <div class = "inputSpace">
                  <md-field :class="getValidationClass('dataForm.poolContract')">
                    <label for="poolContract">Pool Contract</label>
                    <md-input name="poolContract"
                              id="poolContract"
                              autocomplete="new-password"
                              v-model="dataForm.poolContract"
                    />
                  </md-field>
                </div> -->

              </div>

          
            </div>

            <!-- <div class = "inputBoxDoubleDoitem">
              <div class = "inputSpace" v-if="dataForm.deliveryType != 'YY'">
                <md-field>
                    <label>WTicket</label>
                    <md-input v-model="dataForm.scanWt"/>
                </md-field>
              </div>
              <div class = "inputSpace" v-if="dataForm.deliveryType != 'YY'">
                <md-field>
                    <label>Tare Weight</label>
                    <md-input v-model="dataForm.tareWeight"/>
                </md-field>
              </div>
              <div class = "inputSpace" v-if="dataForm.deliveryType != 'YY'">
                <md-field>
                    <label>Gross Weight</label>
                    <md-input v-model="dataForm.vgmWeight"/>
                </md-field>
              </div>
              <div class = "inputSpace" v-if="dataForm.deliveryType != 'YY'">
                <md-field>
                    <label>Net Weight</label>
                    <md-input v-model="dataForm.weight"/>
                </md-field>
              </div>
            </div> -->

          <div class = "alwaysShow">
            <callingApiCenter type="bar" :paths="['/api/w/gst/loadlist/create','/api/w/users',
                                                  '/api/w/gst/loadlist', '/api/w/gst/createyardstage',
                                                  '/api/w/DOs/WebDoASNCount']"></callingApiCenter>
            <div v-if="mode == 'createItem'">
              <md-dialog-actions >
                <md-button class="md-raised" @click="cancalAction"><span class="icons-center material-icons">cancel</span>Cancel</md-button>
                <md-button type="submit" class="md-raised md-primary"><span class="icons-center material-icons">create</span>Create</md-button>
              </md-dialog-actions>
            </div>
            <div v-if="mode == 'updateItem'">
              <md-dialog-actions>
                <md-button class="md-raised md-accent" @click="doVoid"><span class="icons-center material-icons">delete_forever</span>Void</md-button>
                <md-button class="md-raised" @click="cancalAction"><span class="icons-center material-icons">cancel</span>Cancel</md-button>
                <md-button type="submit" class="md-raised md-primary"><span class="icons-center material-icons">update</span>Save</md-button>
              </md-dialog-actions>
            </div>
          </div>

        </form>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>


<style scoped>

 form {
    min-width: 900px;
    margin: 0px;
  }

  .alwaysShow {
    /* position: fixed; */
    right: 0px;
    top : 0px;
  }

  .icons-center {
    color: rgb(25, 37, 105);
  }

  /* .custButton {
    margin: 0px;
    width: 100px;
    height: 30px;
    line-height: 10px;
    font-size: 0.7rem; 
  } */

  .heading{
    padding-top: 10px;
    margin-bottom: 0;
    color: blue;
    width: 100%;
    line-height: 1;
    font-size: 26px;
    font-family: Roboto Slab;
    margin-left: 30px;
  }



  .inputBoxDoubleDoitem {
  width: 1000px;
  /* justify-content: space-around; */
  display: flex;
  flex-direction: row;
  margin: auto;
}

.inputSpace {
  font-size: 18px;
  height: auto;
  width: 180px;
  line-height: 1em;
  background-color: rgb(220, 241, 244);
}

.inputSpaceDisable {
  font-size: 18px;
  height: auto;
  width: 180px;
  line-height: 1em;
  background-color: rgb(246, 248, 224);
}



</style>

<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  import dateFormat from '../utils/dateFormat';
  import { minLength, required , maxLength} from 'vuelidate/lib/validators';
  import AutocompleteCcicLocationSelect from "./AutocompleteCcicLocationSelect.vue";
  import AutocompleteSelect from "./AutoCompleteDebounceSelect.vue";
  import callingApiCenter from "../components/CallingApiCenter.vue";
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';
import moment from 'moment';

  const getInitialdataForm = () => ({
    salesOffice: null,
    source: null,
    transloadingYard: null,
    receivingWindows: null,
    ctnrType: null,
    containerNo: null,
    chassisNo: null,
    ownChassis: null,
    chassisVendor: null,
    carrier: null,
    pickupLocation: null,
    moveInDate: moment(new Date()).format('MM/DD/YYYY'),
    moveInDateLocal: null,
    moveInTime: '00:00:00',
    chzStartDate: moment(new Date()).format('MM/DD/YYYY'),
    chzStartDateLocal: null,
    chzStartTime: '00:00:00',
    moveInBy: null,
    loadStatus: 'EPT',
    scac:null,
    yard: null,
    locationNumber: null,
    poolContract: null,
    fallbackStart: null,
    fallbackEnd: null,
    chzDefault: false,
    scale: null,
    deliveryOrder: null,
    exti2: null,
    customerRef: null,
    deliveryType: null,
    
  });

  const getInitialrequestForm= () => ({
    salesOffice: null,
    deliveryOrder: null,
  });

  export default {
    components: { AutocompleteCcicLocationSelect ,callingApiCenter,AutocompleteSelect},
    mixins: [validationMixin],
    props: {
      mode: String,
      action: Function,
    },
    data: () => ({
      showDialog: false,
      dataForm: getInitialdataForm(),
      loadList: [],
      timeError: null,
      request: getInitialrequestForm(),


    }),
    computed: {
      ...mapGetters([
        'getMasterDataByGroup',
        'getMasterDataName',
        'getUserProfile',
      ]),
      
    },

    validations: {
      dataForm: {
        salesOffice:{
          required,
          },
        source: {
          required,
          },
        transloadingYard: {
          required,
          },
        receivingWindows: {
          required,
          },
        ctnrType: {
          required,
          },
        containerNo: {
            minLength: minLength(10),
            maxLength: maxLength(11),
          },
        chassisNo: {
            minLength: minLength(9),
            maxLength: maxLength(15),
          },
        moveInDate:{
          required,
          },
        moveInTime:{
            required,
            add : (value) => {
              const res = moment('2021-04-01T' + value).toDate();
              return res != 'Invalid Date';
            }
          },
        chzStartTime:{
            required,
            add : (value) => {
              const res = moment('2021-04-01T' + value).toDate();
              return res != 'Invalid Date';
            }
          },
        loadStatus:{
            required,
          },

        ownChassis: {}, 
        scac: {}, 
        chassisVendor:{}, 
        carrier:{}, 
        pickupLocation:{}, 
        moveInBy:{}, 
        yard:{}, 
        locationNumber:{}, 
        poolContract: {},
      },
    },


    methods: {
     async openDialog(existingUser) {
        this.$store.commit('clearApiError');
        this.$v.dataForm.$reset();
        console.log(this.$v.dataForm.$invalid);
        this.request = getInitialrequestForm();
        this.dataForm = getInitialdataForm();
        this.dataForm.chzDefault = false;
        this.dataForm.username = this.getUserProfile.username;
        this.dataForm.transloadingYard = '1010001';

        if (existingUser && this.mode === 'createItem') {
          this.dataForm.salesOffice = existingUser.salesOffice;
          this.dataForm.receivingWindows = existingUser.receivingWindows;    
          this.dataForm.deliveryOrder = existingUser.deliveryOrder;
          this.dataForm.deliveryType = existingUser.deliveryType;
          if ( existingUser.deliveryType === 'YI') {
            this.dataForm.loadStatus = 'LD';
          };
        }

        if (existingUser && this.mode === 'updateItem') {
          this.dataForm = existingUser;
          this.dataForm.seqNo = existingUser.seqNo;
          this.dataForm.salesOffice = existingUser.salesOffice;
          this.dataForm.source = existingUser.source;
          this.dataForm.transloadingYard = existingUser.transloadingYard;
          this.dataForm.receivingWindows = existingUser.receivingWindows;
          this.dataForm.ctnrType = existingUser.ctnrType;
          this.dataForm.containerNo = existingUser.containerNo;
          this.dataForm.chassisNo = existingUser.chassisNo;
          this.dataForm.ownChassis =  existingUser.ownChassis;
          this.dataForm.chassisVendor = existingUser.chassisVendor;
          this.dataForm.carrier = existingUser.carrier;
          this.dataForm.pickupLocation = existingUser.pickUpLocation;
          this.dataForm.moveInDate = dateFormat.date(existingUser.moveInDate);
          this.dataForm.moveInTime = dateFormat.time(existingUser.moveInDate);
          this.dataForm.chzStartDate = dateFormat.date(existingUser.chzStartDate);
          this.dataForm.chzStartTime = dateFormat.time(existingUser.chzStartDate);
          this.dataForm.moveInBy = existingUser.moveInBy;
          this.dataForm.loadStatus = existingUser.loadStatus;
          this.dataForm.scac = existingUser.scac;
          this.dataForm.yard = existingUser.yard;
          this.dataForm.locationNumber = existingUser.locationNumber;
          this.dataForm.poolContract = existingUser.poolContract;
          this.dataForm.deliveryOrder = existingUser.deliveryOrder;
          // this.dataForm.moveInDateLocal = dateFormat.gstDateFormat(existingUser.moveInDate);
          
        }

        this.showDialog = true;
      },


    getValidationRadio(fieldName) {
      const field = _(this.$v).lookup(fieldName);

      if (field) {
        return {
          ErrorMessage: field.$invalid && field.$dirty,
        };
      }
      return {};
    },


      handlePickLocationChanged(item) {
        if (item) {
          this.dataForm.pickupLocation = item.tagId;
        } else {
          this.dataForm.pickupLocation = null;
        }
      },

      handleWindowsChanged(id) {
        this.dataForm.receivingWindows = id;
    },


    handleCtnrTypeChanged(id) {
      this.dataForm.ctnrType = id;
    },

       handleSalesOfficeChanged(id) {
        this.dataForm.salesOffice = id;
      },

      handleSourceChanged(id) {
        this.dataForm.source = id;
      },
      handleStatusChanged(id) {
        this.dataForm.loadStatus = id;
      },

      handleChassisVendorChanged(id) {
        this.dataForm.chassisVendor = id;
      },


      handleCarrierChanged({id,tagName}) {
        console.log(id);
        console.log(tagName);
        this.dataForm.carrier = tagName;
        this.dataForm.scac = id;
      },

       handleScacChanged(id) {
        //this.dataForm.scac = id;
      },


      handleDriverChanged(id) {
        this.dataForm.moveInBy = id;
      },


      
      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },

      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },

      
      handleStatusChanged(id, name) {
        console.log(`handleStatusChanged`, id, name);
        this.dataForm.loadStatus = id;
        //this.dataForm.loadStatus = name;
      },

      cancalAction(){
          this.showDialog = false;
          this.$store.commit('clearApiError');
      },

      doVoid(){

        if (!window.confirm('Void cannot be un-done! Are you sure you want to Void this item?')) {
           return;
         }

        this.timeError = null;
        this.$v.dataForm.$touch();
        this.dataForm.fallbackStart = moment().subtract(1,'months').startOf('d').toDate();
        this.dataForm.fallbackEnd = moment().endOf('d').toDate();
        

         if (this.mode=='update' || this.mode=='updateItem')
        {
            this.dataForm.action = "MODIFY";
        }


        this.dataForm.loadStatus = 'VD'


        console.log(`doSaveUser , invalid=${this.$v.dataForm.$invalid}`);
        // console.log(`Form data is ${JSON.stringify(this.dataForm)}`);

        if (this.$v.dataForm.$invalid) {
        //  this.$refs.top.$el.focus();
          return;
        }
      
        //api.post("/api/w/gst/loadlist/create", this.dataForm)
        newAPIPost("/api/w/gst/loadlist/create", this.dataForm)
          .then((item) => {
            this.$store.commit('clearApiError');
            this.showDialog = false;
            // $('.btn-search-loadlist-container')
            //   .click();
            //  this.action(item.loadKey || item.seqNo, this.mode);

            this.request.salesOffice = this.dataForm.salesOffice
            this.request.deliveryOrder = this.dataForm.deliveryOrder

            //api.post("/api/w/DOs/WebDoASNCount", this.request)
            newAPIPost("/api/w/DOs/WebDoASNCount", this.request)
              .then((res) => {
                this.$store.commit('clearApiError');
                this.showDialog = false;
                window.confirm('Container/Load Void! Please "Search" to see the update.');
              });

          });

      },

      doSaveUser() {
        this.timeError = null;
        this.$v.dataForm.$touch();
        this.dataForm.fallbackStart = moment().subtract(1,'months').startOf('d').toDate();
        this.dataForm.fallbackEnd = moment().endOf('d').toDate();
        
        if (this.mode=='create' || this.mode=='copy' || this.mode== 'createItem')
        {
            this.dataForm.action = "CREATE";
        }

         if (this.mode=='update' || this.mode=='updateItem')
        {
            this.dataForm.action = "MODIFY";
        }


        if (this.mode=='delete')
        {
            this.dataForm.action = "DELETE";
        }

        this.dataForm.salesOffice = this.dataForm.salesOffice == null ? this.dataForm.salesOffice : this.dataForm.salesOffice.toUpperCase();
        this.dataForm.source = this.dataForm.source == null ? this.dataForm.source : this.dataForm.source.toUpperCase();
        this.dataForm.containerNo = this.dataForm.containerNo == null ? this.dataForm.containerNo : this.dataForm.containerNo.toUpperCase();
        this.dataForm.chassisNo = this.dataForm.chassisNo == null ? this.dataForm.chassisNo : this.dataForm.chassisNo.toUpperCase();
        this.dataForm.scac = this.dataForm.scac == null ? this.dataForm.scac : this.dataForm.scac.toUpperCase();
        this.dataForm.chassisVendor = this.dataForm.chassisVendor == null ? this.dataForm.chassisVendor : this.dataForm.chassisVendor.toUpperCase();
        this.dataForm.carrier = this.dataForm.scac == null ? this.dataForm.scac : this.dataForm.scac.toUpperCase();
        this.dataForm.pickupLocation = this.dataForm.pickupLocation == null ? this.dataForm.pickupLocation : this.dataForm.pickupLocation.toUpperCase();
        this.dataForm.moveInBy = this.dataForm.moveInBy == null ? this.dataForm.moveInBy : this.dataForm.moveInBy.toUpperCase();
      //  this.dataForm.yard = this.dataForm.yard == null ? this.dataForm.yard : this.dataForm.yard.toUpperCase();
      //  this.dataForm.locationNumber = this.dataForm.locationNumber == null ? this.dataForm.locationNumber : this.dataForm.locationNumber.toUpperCase();
      //  this.dataForm.scanWt = this.dataForm.scanWt == null ? this.dataForm.scanWt : this.dataForm.scanWt.toUpperCase();
      //  this.dataForm.tareWeight = Number(this.dataForm.tareWeight);
      //  this.dataForm.vgmWeight = Number(this.dataForm.vgmWeight);
      //  this.dataForm.weight = Number(this.dataForm.weight);



        // console.log(`doSaveUser , invalid=${this.$v.dataForm.$invalid}`);
        // // console.log(`Form data is ${JSON.stringify(this.dataForm)}`);

        // if (this.$v.dataForm.$invalid) {
        // //  this.$refs.top.$el.focus();
        //   return;
        // }
        
        const timeRefM = moment('2021-04-01T' + this.dataForm.moveInTime).format('HH:mm:ss');
        const timeRefC = moment('2021-04-01T' + this.dataForm.moveInTime).format('HH:mm:ss');
        this.dataForm.moveInDate = dateFormat.getLocalDateOnly(this.dataForm.moveInDate) + 'T' + timeRefM;

        if (this.dataForm.chzStartDate == null || this.dataForm.chzStartDate == '')
        {
          // this.dataForm.chzDefault = true
          this.dataForm.chzStartDate = this.dataForm.moveInDate
        }
        else
        {
          this.dataForm.chzStartDate = dateFormat.getLocalDateOnly(this.dataForm.chzStartDate) + 'T' + timeRefC;
        }




        console.log(`Form data is ${JSON.stringify(this.dataForm)}`);
      
        //api.post("/api/w/gst/loadlist/create", this.dataForm)
        newAPIPost("/api/w/gst/loadlist/create", this.dataForm)
          .then((item) => {
            this.$store.commit('clearApiError');
            this.showDialog = false;
            // $('.btn-search-loadlist-container')
            //   .click();
            //  this.action(item.loadKey || item.seqNo, this.mode);

            this.request.salesOffice = this.dataForm.salesOffice
            this.request.deliveryOrder = this.dataForm.deliveryOrder

            //api.post("/api/w/DOs/WebDoASNCount", this.request)
            newAPIPost("/api/w/DOs/WebDoASNCount", this.request)
              .then((res) => {
                this.$store.commit('clearApiError');
                this.showDialog = false;
                window.confirm('Container/Load created! Please "Search" to see the update.');
              });

          });
      },
    },
  };
</script>
